// extracted by mini-css-extract-plugin
module.exports = {"background":"styles_background__OuJ97","container":"styles_container__07TOB"};